import { PortalLayer, OnLayerHolderRef, OnLayersChanged } from "./types"

const layers: Map<number, PortalLayer> = new Map()

const layersChangedSubscribers = new Set<OnLayersChanged>()

function notifyLayersChanged() {
  layersChangedSubscribers.forEach((listener) => listener())
}

export function addOrUpdateLayer(layer: PortalLayer) {
  layers.set(layer.id, layer)
  notifyLayersChanged()
}

export function removeLayer(id: number) {
  layers.delete(id)
  notifyLayersChanged()
}

export function subscribeLayersChange(listener: OnLayersChanged) {
  layersChangedSubscribers.add(listener)
  return () => {
    layersChangedSubscribers.delete(listener)
  }
}

export function getLayers() {
  return Array.from(layers.values())
}
